export default "__VITE_ASSET__Cg5XdL5Y__"